import { render, staticRenderFns } from "./AddArtistWizardStepSelectPlan.vue?vue&type=template&id=7441bfea&scoped=true&"
import script from "./AddArtistWizardStepSelectPlan.vue?vue&type=script&lang=js&"
export * from "./AddArtistWizardStepSelectPlan.vue?vue&type=script&lang=js&"
import style0 from "./AddArtistWizardStepSelectPlan.vue?vue&type=style&index=0&id=7441bfea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7441bfea",
  null
  
)

export default component.exports